import { Treeselect } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import cloneDeep from "lodash/cloneDeep";
import TreeselectAddable from "@@/core/components/product/shared/TreeselectAddable/TreeselectAddable";
import productModelToData from "@@/core/components/product/classes/productModelToData";
import variety from "@@/core/components/product/classes/variety";
import InputGroup from "@@/core/components/product/shared/InputGroup/InputGroup";
import configProvider from "@@/core/configProvider";
import debounce from "lodash.debounce";
import {
  BFormGroup,
  BFormInput,
  BModal,
  VBModal,
  VBToggle,
} from "bootstrap-vue";
import Swal from "sweetalert2";
import { filter, forEach } from "lodash";

export default {
  name: "ProductColors",
  configProvider,
  directives: {
    "b-toggle": VBToggle,
    "b-modal": VBModal,
  },
  components: {
    TreeselectAddable,
    Treeselect,
    InputGroup,
    BFormGroup,
    BFormInput,
    BModal,
  },
  props: {
    allAttributes: Array,
    defaultSeleted: Array,
  },
  data() {
    return {
      normalizer(node) {
        return {
          id: node.id,
          label: node.value,
        };
      },
      colorsItems: {},
      attributeOption: {},
      selectedallAttributes: [],
      custom_attributes: [],
    };
  },

  methods: {
    changColorsItems(e){
      // console.log(this.colorsItems,"openOnClick openOnClick");
      // console.log(e, "meysammmmmmmmmmm2222");
      this.custom_attributes=[]
      // console.log(typeof newVal, "meysammmmmmmmmmm2222");
      for (const key in this.colorsItems) {
        // console.log(key + ":" +this.colorsItems[key.toString()]);
        let colorsItemsArray = [];
        this.colorsItems[key].forEach((item) => {
          colorsItemsArray.push(item.id);
        });
        this.custom_attributes.push({
          attribute_id: key,
          attribute_values: colorsItemsArray,
        });
      }
      // console.log(this.custom_attributes, "this.custom_attributes");
      this.$emit("setCustomAttributes",this.custom_attributes)
    },
    addOption(attr, opt) {
      console.log(attr, opt);
      this.attributeOption[attr.id] = opt;
      console.log("111111");
    },
    getOptions(attribute) {
      let fromAdded = this.addedAttributeOptions[attribute.id];
      if (!fromAdded) {
        fromAdded = [];
      }

      return this.$root.addLabel(fromAdded);
    },
    findeVluesAttributes(id){
     return this.allAttributes.find(item=>item.id==id)
    }
  },
  watch: {
    selectedallAttributes(newVal) {
      console.log(newVal, "meysammmmmmmmmmm111111");
      
    },
    // "'colorsItems'.7": function(newVal){
    //   alert(123)
    //   console.log(newVal,"meysammmmmmmmmmm2222");
    //   // for (const key in newVal) {
    //   //   console.log(key+":"+ newVal);
    //   //   let colorsItemsArray=[]
    //   //   newVal[key].forEach(item => {
    //   //     colorsItemsArray.push(item.id)
    //   //   });
    //   //   this.custom_attributes.push({attribute_id:key , attribute_values:colorsItemsArray})
    //   // }
    //   // console.log(this.custom_attributes,"this.custom_attributes");
    // },
    // colorsItems: {
    //   handler(newVal) {
    //     {
    //       console.log(newVal, "meysammmmmmmmmmm2222");
    //       this.custom_attributes=[]
    //       // console.log(typeof newVal, "meysammmmmmmmmmm2222");
    //       for (const key in newVal) {
    //         console.log(key + ":" + newVal[key.toString()]);
    //         let colorsItemsArray = [];
    //         newVal[key].forEach((item) => {
    //           colorsItemsArray.push(item.id);
    //         });
    //         this.custom_attributes.push({
    //           attribute_id: key,
    //           attribute_values: colorsItemsArray,
    //         });
    //       }
    //       // console.log(this.custom_attributes, "this.custom_attributes");
    //       this.$emit("setCustomAttributes",this.custom_attributes)
    //     }
    //   },
    //   deep: true,
    // },
  },
  mounted(){
    // this.colorsItems=[]
    // console.log(this.defaultSeleted , "defaultSeleted defaultSeleteddefaultSeleted");
    // console.log(this.colorsItems,"this.colorsItemsthis.colorsItems");

    if(this.defaultSeleted!=null && this.defaultSeleted.length){
     
      this.defaultSeleted.forEach(item=>{
        let Array=[]
        this.selectedallAttributes.push({id:item.attribute_id})
        let key=item.attribute_id
        item.attribute_values.forEach(value=>{
          let arrId=this.findeVluesAttributes(key).values.filter(item=>item.id==value)
          // console.log(arrId,"arrId arrId");
          Array.push(arrId[0])
        })
        this.colorsItems[key]= Array
      })
      
    }
    // console.log(this.allAttributes,"allAttributes allAttributes");
    // console.log(this.colorsItems,"this.colorsItemsthis.colorsItems");
    // console.log(this.selectedallAttributes,"this.selectedallAttributes.selectedallAttributes");
  }
};
